// extracted by mini-css-extract-plugin
module.exports = {"root":"FixedContainer_root__bzSeD","inner":"FixedContainer_inner__vhMS3"};